import React from 'react';
type PageHeaderProps = {
  overline: string;
  title: string;
  description?: string;
};
export function PageHeader({
  overline,
  title,
  description
}: PageHeaderProps) {
  return <header className="max-w-3xl" data-id="element-29" data-mp="3rem0zk4adgrx">
      <p className="font-sans text-[11px] font-semibold uppercase tracking-overline text-emerald" data-id="element-30" data-mp="3rdkn77vvyg6i">
        {overline}
      </p>
      <h1 className="mt-5 font-display text-4xl leading-[1.15] text-navy sm:text-5xl" data-id="element-31" data-mp="3mgamgw31qi3d">{title}</h1>
      {description && <p className="mt-6 max-w-2xl font-sans text-[17px] leading-relaxed text-navy-600" data-id="element-32" data-mp="2ynlvf4qb44y5">
          {description}
        </p>}
    </header>;
}